export default {"src":"/_next/static/media/pain.8e65f765.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};